import { IframeRequests } from "@/utils/iframeUtility.ts";

/**
 * Get the API token from the parent context to authenticate HTTP requests.
 */
export function getAPIToken(): Promise<null | string> {
  return IframeRequests("getAPIToken").catch(() => null);
}

/**
 * Tells the parent context to update the current URL path, without reloading it.
 * This is to give the illusion of navigating at the top level when you are actually
 * navigating within the iframe.
 */
export async function updatePath(path: string): Promise<null> {
  return IframeRequests("updatePath", path).catch(() => null);
}

/**
 * Reads the localStorage item by key from the parent context
 */
export async function localStorageRead(itemKey: string): Promise<null | string> {
  return IframeRequests("localStorage:read", itemKey).catch(() => null);
}

/**
 * Reads the localStorage item by key from the parent context
 */
export async function localStorageWrite(key: string, value: string): Promise<null | string> {
  return IframeRequests("localStorage:write", {key, value}).catch(() => null);
}

/**
 * Reads the sessionStorage item by key from the parent context
 */
export async function sessionStorageRead(itemKey: string): Promise<null | string> {
  return IframeRequests("sessionStorage:read", itemKey).catch(() => null);
}

/**
 * Reads the sessionStorage item by key from the parent context
 */
export async function sessionStorageWrite(key: string, value: string): Promise<null | string> {
  return IframeRequests("sessionStorage:write", {key, value}).catch(() => null);
}

/**
 * Execute a specific mutation call with the given payload in the parent Vuex store.
 */
export function vuexStoreWriteMutation(mutator: string, payload: object): Promise<null | string> {
  return IframeRequests("vuexStore:mutation:write", {mutator, payload}).catch(() => null);
}